
import api from './api';

class Stats {

	constructor (Api, Session) {
		this.Api = Api;
	}

	summary (query) {
		return this.Api.get({
			url:  'v1.1/m/summary',
			query
		});
	}

}

Stats.$inject = ['Api'];

export default angular.module('service.stat', [api])
	.service('Stats', Stats)
	.name;



// WEBPACK FOOTER //
// ./src/service/stats.js